
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ROLE_LOGIN_PATHS = {
  ADMIN: "/admin/login",
  ZSM: "/zsm/login",
  ASM: "/asm/login",
  SM: "/sm/login",
};

const Logout = ({ role }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Capture the current role before clearing the session.
    let storedRole = String(
      role || localStorage.getItem("role") || ""
    )
      .trim()
      .toUpperCase();

    // If the role is missing, try getting it from the saved session.
    if (!storedRole) {
      try {
        const session = JSON.parse(
          localStorage.getItem("userSession") || "{}"
        );

        storedRole = String(
          session?.user?.role ||
          session?.user?.userlevel ||
          session?.role ||
          ""
        )
          .trim()
          .toUpperCase();
      } catch (error) {
        console.error("Unable to read user session:", error);
      }
    }

    // Resolve the login route before removing session data.
    const loginPath = ROLE_LOGIN_PATHS[storedRole] || "/admin/login";

    // Clear authentication and role-specific IDs.
    const storageKeys = [
      "userSession",
      "role",
      "admin_id",
      "zsm_id",
      "asm_id",
      "sm_id",
      "admin_token",
      "zsm_token",
      "asm_token",
      "sm_token",
    ];

    storageKeys.forEach((key) => {
      localStorage.removeItem(key);
    });

    // Redirect to the corresponding login page.
    navigate(loginPath, { replace: true });
  }, [navigate, role]);

  return (
    <div className="container-fluid py-5 text-center">
      <div
        className="spinner-border text-primary mb-3"
        role="status"
        aria-label="Logging out"
      />

      <h5 className="mb-2">Logging out...</h5>

      <p className="text-muted mb-0">
        Redirecting you to your login page.
      </p>
    </div>
  );
};

export default Logout;
